import createAxios from './axiosHttp';

function getEntitiesNotRegistered() {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/entities-not-registered`;
    return axios.get(urlPath);
}

function getOrders() {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/order`;
    return axios.get(urlPath);
}

function getOrdersBack() {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/order_back`;
    return axios.get(urlPath);
}

function getPurchases() {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/purchase`;
    return axios.get(urlPath);
}

function getOrderStock(pagination) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/order/stock`;

    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }

    return axios.get(urlPath);
}

function getProductStock(pagination) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/product/stock`;

    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }

    return axios.get(urlPath);
}

function getWarehousesStock() {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/warehouse/stock`;
    return axios.get(urlPath);
}

// Blocks of the redesigned (v2) dashboard: one endpoint each, filtered by the
// selected period (only yesterday, or 7, 30 or 90 days). Alerts take no period.
function getOverviewBlock(path, params) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));

    let urlPath = `/dashboard/${user.extraData.customerId}/${path}`;
    return axios.get(urlPath, { params });
}

function getKpis(days) {
    return getOverviewBlock('kpis', { days });
}

function getOrderStatus(days) {
    return getOverviewBlock('order-status', { days });
}

function getPreparationTime(days) {
    return getOverviewBlock('preparation-time', { days });
}

function getShipmentsByCourier(days) {
    return getOverviewBlock('shipments-by-courier', { days });
}

function getStockBreaks(days, limit) {
    return getOverviewBlock('stock-breaks', { days, limit });
}

function getTopProducts(days, limit) {
    return getOverviewBlock('top-products', { days, limit });
}

function getAlerts() {
    return getOverviewBlock('alerts');
}

export const dashboardService = {
    getKpis,
    getOrderStatus,
    getPreparationTime,
    getShipmentsByCourier,
    getStockBreaks,
    getTopProducts,
    getAlerts,
    getOrders,
    getOrdersBack,
    getPurchases,
    getOrderStock,
    getProductStock,
    getWarehousesStock,
    getEntitiesNotRegistered
 };